module.exports = __webpack_public_path__ + "static/img/添可芙万ArtStation美学空间站.38fd2c17.png";